import React, { useContext } from "react";
import { env } from "../../datas.config";
import { AuthContext } from "../../contexts/AuthContext";
import { DisplayDiscussionForMiniScreenContext } from "../../contexts/DisplayDiscussionForMiniScreenContext";
import { getBgGradient } from "./CreateAnnonceModal";
import Person from "../Person";

export default function AnnoncesList({ annonces, activeIndex, onSelect }) {
  const { user } = useContext(AuthContext);
  const { setDisplayDiscussionForMiniScreen } = useContext(DisplayDiscussionForMiniScreenContext);

  const getTempsRestant = (expiresAt) => {
    const now = new Date();
    const expDate = new Date(expiresAt);
    const diff = expDate - now;
    if (diff <= 0) return "Expiré";
    const jours = Math.floor(diff / (1000 * 60 * 60 * 24));
    const heures = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    if (jours > 0) return `${jours}j ${heures}h`;
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    if (heures > 0) return `${heures}h ${minutes}min`;
    return `${minutes}min`;
  };

  const getExtrait = (annonce) => {
    if (annonce.type === "texte") {
      const texte = typeof annonce.contenu === "string" ? annonce.contenu : "";
      return texte.length > 60 ? texte.substring(0, 60) + "..." : texte;
    }
    return annonce.contenu?.legende || "Image";
  };

  return (
    <ul className="tyn-media-list gap gap-2">
      {annonces.length === 0 ? (
        <li className="text-center py-4 text-muted">
          Aucune annonce pour le moment
        </li>
      ) : (
        annonces.map((annonce, idx) => (
          <li
            key={annonce._id}
            className={`tyn-media-group py-2 px-3 rounded ${
              idx === activeIndex ? "bg-light" : ""
            }`}
            style={{ cursor: "pointer" }}
            onClick={() => {
              onSelect(idx);
              setDisplayDiscussionForMiniScreen(true);
            }}
          >
            <div className="tyn-media">
              {annonce.type === "image" ? (
                <div
                  className="rounded"
                  style={{
                    width: 44,
                    height: 44,
                    backgroundImage: `url(${env.domain}/api/auth/annonces/${annonce.contenu?.imageUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    flexShrink: 0,
                  }}
                />
              ) : (
                <div
                  className="rounded d-flex align-items-center justify-content-center"
                  style={{
                    width: 44,
                    height: 44,
                    background: getBgGradient(annonce.bgColor),
                    flexShrink: 0,
                  }}
                >
                  <span style={{ color: "#fff", fontSize: "0.65rem", fontWeight: 600, textAlign: "center", lineHeight: 1.1, padding: 2, overflow: "hidden" }}>
                    Aa
                  </span>
                </div>
              )}
            </div>
            <div className="tyn-media-col">
              <div className="tyn-media-row">
                <h6 className="name mb-0" style={{ fontSize: "0.85rem" }}>
                  {annonce.emetteur?.prenom} {annonce.emetteur?.nom}
                </h6>
                <span className="text-muted" style={{ fontSize: "0.7rem" }}>
                  {getTempsRestant(annonce.expiresAt)}
                </span>
              </div>
              <div className="tyn-media-row">
                <p className="content mb-0 text-muted" style={{ fontSize: "0.8rem" }}>
                  {getExtrait(annonce)}
                </p>
              </div>
            </div>
          </li>
        ))
      )}
    </ul>
  );
}
